import React, { useContext } from "react";
//Elements
import { isAuthenticated } from "./admin/services/auth";
import { isAuthenticatedCustomer } from "./customer/services/CustomerAuth";
import { isAuthenticatedTutor } from "./tutor/services/TutorAuth";
// Navigation bars
import AdminNavigation from "./admin/structure/AdminNavigation.js";
import PublicNavigationBar from "./common/PublicNavigationBar";
import CustomerNavigationBar from "./customer/structure/CustomerNavigationBar";
import TutorNavigationBar from "./tutor/structure/TutorNavigationBar";
import { BusinessContextConsumer } from "./BusinessContext.js";

const NavigationBars = () => {
  const context = useContext(BusinessContextConsumer);
  const { brandColour, generalTheme } = context;
  return (
    <div>
      {isAuthenticated() && !isAuthenticatedCustomer() && !isAuthenticatedTutor() && (
        <AdminNavigation brandColour={brandColour} generalTheme={generalTheme}/>
      )}

      {isAuthenticatedCustomer() && !isAuthenticated() && !isAuthenticatedTutor() && (
        <CustomerNavigationBar brandColour={brandColour} generalTheme={generalTheme}/>
      )}

      {isAuthenticatedTutor() && !isAuthenticated() && !isAuthenticatedCustomer() && (
        <TutorNavigationBar brandColour={brandColour} generalTheme={generalTheme}/>
      )}

      {!isAuthenticatedCustomer() && !isAuthenticated() && !isAuthenticatedTutor() && (
        <PublicNavigationBar brandColour={brandColour} generalTheme={generalTheme}/>
      )}
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 200' className='topWave'>
        <path
          fill={brandColour}
          fillOpacity='1'
          d='M0,128L48,117.3C96,107,192,85,288,85.3C384,85,480,107,576,106.7C672,107,768,85,864,74.7C960,64,1056,64,1152,64C1248,64,1344,64,1392,64L1440,64L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z'
        ></path>
      </svg>
    </div>
  );
};

export default NavigationBars;
